import {useState} from 'react'
import {useSWRConfig} from 'swr'

import {fetcher, postHeaders} from '~/api'
import {useRails} from '~/react/contexts/rails'

// Permanently dismisses the rewards dashboard promo banner ("Never show again")
// by recording a timestamp on the supplier's product configuration, then
// revalidates the permissions cache so the banner disappears immediately.
export const useDismissRewardsBanner = () => {
  const {
    authenticityToken,
    currentSupplier: {id: supplierId},
  } = useRails()
  const {mutate} = useSWRConfig()
  const [isDismissing, setIsDismissing] = useState(false)

  const dismiss = async () => {
    setIsDismissing(true)

    try {
      await fetcher(
        `/payments_on_demand/api/suppliers/${supplierId}/rewards_dashboard_banner`,
        postHeaders({authenticityToken}),
      )

      await mutate(
        `/payments_on_demand/api/suppliers/${supplierId}/permissions`,
      )
    } finally {
      setIsDismissing(false)
    }
  }

  return {dismiss, isDismissing}
}
